import { Box, Container, ContainerProps } from "@mui/material";
import React from "react";
import { Bg } from "src/assets";
import { createStyles } from "src/main/utils";

interface ContentProps extends React.PropsWithChildren, ContainerProps {}

const Content: React.FC<ContentProps> = (props) => {
  const { children, ...containerProps } = props;

  return (
    <Box sx={styles.root}>
      <Box sx={styles.bg} />

      <Container
        {...containerProps}
        sx={styles.container}
      >
        {children}
      </Container>
    </Box>
  );
};

const styles = createStyles({
  root: {
    backgroundColor: "#0D0D0D",
    minHeight: "100vh",
  },
  bg: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundImage: `url(${Bg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    filter: "blur(2px)",
  },
  container: {
    height: "100%",
    px: 0,
  },
});

export default Content;
